import { excuseApi } from "../commons/http";

class Menu {
  constructor(data = {}) {
    this.id = data.id;
    this.user_id = data.user_id;
    this.user_package_id = data.user_package_id;
    this.title = data.title || '';
    this.subtitle = data.subtitle || '';
    this.total_weight = data.total_weight || 0;
    this.package_weight = data.package_weight || 0;
    this.bonus_weight = data.bonus_weight || 0;
    this.total_deliveries = data.total_deliveries || 8;
    this.delivery_days = data.delivery_days || '';
    this.customer_name = data.customer_name || '';
    this.customer_address = data.customer_address || '';
    this.notes = data.notes || [];
    this.status = data.status || 'DRAFT';
    this.cycle_start_date = data.cycle_start_date || null;
    this.weeks = data.weeks || [];
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.user = data.user;
    this.created_by = data.created_by;
    this.updated_by = data.updated_by;
  }

  mapData(data) {
    this.id = data.id;
    this.user_id = data.user_id;
    this.user_package_id = data.user_package_id;
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.total_weight = data.total_weight;
    this.package_weight = data.package_weight;
    this.bonus_weight = data.bonus_weight;
    this.total_deliveries = data.total_deliveries;
    this.delivery_days = data.delivery_days;
    this.customer_name = data.customer_name;
    this.customer_address = data.customer_address;
    this.notes = data.notes || [];
    this.status = data.status;
    this.cycle_start_date = data.cycle_start_date || null;
    this.weeks = data.weeks || [];
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.user = data.user;
    this.created_by = data.created_by;
    this.updated_by = data.updated_by;
  }

  async getMenuById(id) {
    try {
      const res = await excuseApi({
        path: `/menus/${id}`,
        method: 'GET',
      });
      if (res.status === 200) {
        return res.data.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching menu:', error);
      throw error;
    }
  }

  async createMenu() {
    try {
      const res = await excuseApi({
        path: '/menus',
        method: 'POST',
        body: this._buildBody(),
      });
      if (res.status === 200 || res.status === 201) {
        return { success: true, message: "Tạo menu thành công", data: res.data.data };
      }
      return { success: false, message: "Tạo menu thất bại" };
    } catch (error) {
      console.error('Error creating menu:', error);
      throw error;
    }
  }

  async updateMenu(id) {
    try {
      const res = await excuseApi({
        path: `/menus/${id}`,
        method: 'PUT',
        body: this._buildBody(),
      });
      if (res.status === 200) {
        return { success: true, message: "Cập nhật menu thành công", data: res.data.data };
      }
      return { success: false, message: "Cập nhật menu thất bại" };
    } catch (error) {
      console.error('Error updating menu:', error);
      throw error;
    }
  }

  async publishMenu(id) {
    try {
      const res = await excuseApi({
        path: `/menus/${id}/publish`,
        method: 'POST',
      });
      if (res.status === 200) {
        return { success: true, url: res.data.url, message: res.data.message };
      }
      return { success: false, message: "Xuất menu thất bại" };
    } catch (error) {
      console.error('Error publishing menu:', error);
      throw error;
    }
  }

  async regenerateOrder(menuId, deliveryId) {
    try {
      const res = await excuseApi({
        path: `/menus/${menuId}/deliveries/${deliveryId}/regenerate_order`,
        method: 'POST',
      });
      if (res.status === 200 || res.status === 201) {
        return { success: true, message: res.data.message, data: res.data.data };
      }
      return { success: false, message: 'Tạo lại đơn hàng thất bại' };
    } catch (error) {
      if (error.response && error.response.status === 409) {
        return { success: false, message: error.response.data.error || 'Đã tồn tại đơn hàng cho lần giao này' };
      }
      console.error('Error regenerating order:', error);
      throw error;
    }
  }

  async generateMenu(userId, userPackageId, additionalInstructions = null) {
    try {
      const body = { user_id: userId, user_package_id: userPackageId };
      if (additionalInstructions) {
        body.additional_instructions = additionalInstructions;
      }
      const res = await excuseApi({
        path: '/menus/generate',
        method: 'POST',
        body,
      });
      if (res.status === 200) {
        return { success: true, data: res.data.data, metadata: res.data.metadata, message: res.data.message };
      }
      return { success: false, message: 'Tạo menu AI thất bại' };
    } catch (error) {
      const msg = error.response?.data?.error || error.response?.data?.message || 'Tạo menu AI thất bại';
      return { success: false, message: msg };
    }
  }

  async deleteMenu(id) {
    try {
      const res = await excuseApi({
        path: `/menus/${id}`,
        method: 'DELETE',
      });
      if (res.status === 200) {
        return { success: true, message: "Xóa menu thành công" };
      }
      return { success: false, message: "Xóa menu thất bại" };
    } catch (error) {
      console.error('Error deleting menu:', error);
      throw error;
    }
  }

  _buildBody() {
    return {
      user_id: this.user_id,
      user_package_id: this.user_package_id || null,
      title: this.title,
      subtitle: this.subtitle || null,
      total_weight: this.total_weight,
      package_weight: this.package_weight,
      bonus_weight: this.bonus_weight,
      total_deliveries: this.total_deliveries,
      delivery_days: this.delivery_days || null,
      customer_name: this.customer_name,
      customer_address: this.customer_address || null,
      notes: this.notes,
      status: this.status,
      cycle_start_date: this.cycle_start_date || null,
      weeks: (() => {
        let globalDeliveryIdx = 0;
        return (this.weeks || []).map((week, wIdx) => ({
          id: week.id || null,
          week_number: week.week_number,
          label: week.label,
          sort_order: wIdx,
          deliveries: (week.deliveries || []).map((delivery, dIdx) => {
            globalDeliveryIdx++;
            const day = delivery.delivery_day || null;
            return {
              id: delivery.id || null,
              delivery_number: globalDeliveryIdx,
              delivery_day: day,
              delivery_date: delivery.delivery_date || null,
              label: day ? `Lần ${globalDeliveryIdx} — ${day}` : `Lần ${globalDeliveryIdx}`,
              total_weight: delivery.total_weight || null,
              sort_order: dIdx,
              items: (delivery.items || []).map((item, iIdx) => ({
                product_id: item.product_id || null,
                name: item.name,
                emoji: item.emoji || null,
                detail: item.detail || null,
                quantity: item.quantity || null,
                convert_rate: item.convert_rate || 1,
                weight_text: item.weight_text,
                weight_value: item.weight_value || null,
                item_type: item.item_type || 'REGULAR',
                sort_order: iIdx,
              })),
            };
          }),
        }));
      })(),
    };
  }
}

export default Menu;
